import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import clone from 'lodash/clone';
import filter from 'lodash/filter';
import { injectIntl, intlShape } from 'react-intl';
import {
    getProductStudents,
    downloadStudentRoll,
    clearFilterValue,
    changeFilterValue,
    updateSearchTerm,
    sortStudentList,
    retrieveSelectedStudents,
    openUnAssignStudentsModal,
    closeStudentsOperationConfirmationModal,
    unassignStudents,
    openAddStudentModal,
    closeAddStudentModal,
    addStudent,
    closeAddStudentValidationModal,
    printSignInCard,
    addAnotherStudentModal,
    openDeleteUserConfirmation,
    deleteStudentRequest,
    openBulkPasswordChangeStudentsModal,
    bulkPasswordChangeStudents,
    clearOperationTypeRequest,
    getClassroomGroups,
    downloadStudentsSignInCards,
    showHideSignInCardModalRequest
} from './actions';
import { resetUserClassroomRelation } from '../../containers/assign-user/actions';
import { showToast } from '../../components/toast/actions';
import messages from './messages';
import StudentRoll from '../../components/student-roll/index';
import { createRows, isListDifferent } from '../../helpers/grid-util';
import { getProductClassrooms } from '../class-roll/actions';
import { trackEvent } from '../../analytics';
import { ANALYTICS_EVENTS, ANALYTICS_MODULES } from '../../analytics/events';

class StudentRollContainer extends Component {
    static propTypes = {
        isStudentDataLoaded: PropTypes.bool,
        isClassroomDataLoaded: PropTypes.bool,
        isSaveInProgress: PropTypes.bool,
        isStudentRollDownloaded: PropTypes.bool,
        isSignInCardDownloaded: PropTypes.bool,
        showAddStudentValidationModal: PropTypes.bool,
        showModal: PropTypes.bool,
        showAddStudentConfirmationModal: PropTypes.bool,
        addStudentValidationMessage: PropTypes.string,
        lastAddedStudentUserProfileId: PropTypes.number,
        student: PropTypes.object,
        dataFilterOption: PropTypes.object,
        students: PropTypes.arrayOf(PropTypes.object),
        classrooms: PropTypes.arrayOf(PropTypes.object),
        filteredStudents: PropTypes.arrayOf(PropTypes.object),
        selectedStudents: PropTypes.arrayOf(PropTypes.number),
        selectedProduct: PropTypes.object,
        getProductStudents: PropTypes.func,
        getProductClassrooms: PropTypes.func,
        downloadStudentRoll: PropTypes.func,
        clearFilterValue: PropTypes.func,
        changeFilterValue: PropTypes.func,
        retrieveSelectedStudents: PropTypes.func,
        updateSearchTerm: PropTypes.func,
        sortStudentList: PropTypes.func,
        unassignStudents: PropTypes.func,
        isUserOperationModalOpen: PropTypes.bool,
        refreshStudentList: PropTypes.bool,
        openUnAssignStudentsModal: PropTypes.func,
        closeStudentsOperationConfirmationModal: PropTypes.func,
        disableConfirmationButton: PropTypes.bool,
        openAddStudentModal: PropTypes.func,
        closeAddStudentModal: PropTypes.func,
        addStudent: PropTypes.func,
        closeAddStudentValidationModal: PropTypes.func,
        printSignInCard: PropTypes.func,
        addAnotherStudentModal: PropTypes.func,
        bulkPasswordChangeStudents: PropTypes.func,
        openBulkPasswordChangeStudentsModal: PropTypes.func,
        openDeleteUserConfirmation: PropTypes.func,
        isDeleteUserModalOpen: PropTypes.bool,
        deleteStudentRequest: PropTypes.func,
        operationType: PropTypes.string,
        showToast: PropTypes.func,
        intl: intlShape.isRequired,
        deletedStudentsCount: PropTypes.number,
        isPartialDelete: PropTypes.bool,
        clearOperationTypeRequest: PropTypes.func,
        getClassroomGroups: PropTypes.func,
        downloadStudentsSignInCards: PropTypes.func,
        classroomGroups: PropTypes.arrayOf(PropTypes.object),
        showHideSignInCardModal: PropTypes.bool,
        showHideSignInCardModalRequest: PropTypes.func,
        resetUserClassroomRelation: PropTypes.func
    };

    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.handleGridSort = this.handleGridSort.bind(this);
        this.rows = props.isStudentDataLoaded ? createRows(props.filteredStudents) : [];
        this.state = {
            rows: this.rows,
            dataFilterOption: this.props.dataFilterOption,
            bulkPasswordValue: ''
        };

        this.handleOnPrintSignInCard = this.handleOnPrintSignInCard.bind(this);
        this.handleOnPrintMultipleSignInCard = this.handleOnPrintMultipleSignInCard.bind(this);
        this.handleOnStudentUnassign = this.handleOnStudentUnassign.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleOnUnassignConfirm = this.handleOnUnassignConfirm.bind(this);
        this.filterClassrooms = this.filterClassrooms.bind(this);
        this.handleOnStudentBulkPasswordChange = this.handleOnStudentBulkPasswordChange.bind(this);
        this.handleOnStudentBulkPasswordChangeNewValue = this.handleOnStudentBulkPasswordChangeNewValue.bind(this);
        this.handleOnBulkPasswordChangeConfirm = this.handleOnBulkPasswordChangeConfirm.bind(this);
        this.handleOnAddStudentGetGroups = this.handleOnAddStudentGetGroups.bind(this);
    }

    componentDidMount() {
        if (!this.props.isStudentDataLoaded) {
            this.props.getProductStudents(this.props.selectedProduct.id);
        }

        if (!this.props.isClassroomDataLoaded) {
            this.props.getProductClassrooms(this.props.selectedProduct.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isStudentDataLoaded ||
            isListDifferent(nextProps.filteredStudents, this.props.filteredStudents, 'userProfileId')) {
            this.rows = createRows(nextProps.filteredStudents);
            this.setState({ rows: this.rows });
        }

        if (nextProps.refreshStudentList && nextProps.refreshStudentList !== this.props.refreshStudentList) {
            this.props.getProductStudents(this.props.selectedProduct.id);
        }

        if (nextProps.isSignInCardDownloaded !== this.props.isSignInCardDownloaded) {
            setTimeout(this.handleOnCloseModal, 1000);
            setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
        }

        this.setState({ dataFilterOption: this.props.dataFilterOption });
    }

    filterClassrooms = (classrooms) => {
        const classes = classrooms.map(item => ({
            key: item.name,
            value: item.name,
            classroomId: item.classroomId
        }));
        return classes;
    }

    handleOnPrintSignInCard(format) {
        const studentProfileIds = [];
        studentProfileIds.push(this.props.lastAddedStudentUserProfileId);
        const studentSignInCardsData = { studentUserProfileIds: studentProfileIds, SignInCardPageSizeType: format };
        this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
    }

    handleOnPrintMultipleSignInCard(format) {
        const studentSignInCardsData = { studentUserProfileIds: this.props.selectedStudents,
            SignInCardPageSizeType: format };
        this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
    }

    handleGridSort(sortColumn) {
        this.props.sortStudentList(sortColumn);
    }

    handleOnDownloadStudentRoll = () => {
        this.props.downloadStudentRoll(this.props.filteredStudents, false);
    }

    handleOnQuickUpload = () => {
        this.context.router.history.push('quickUpload');
    }

    handleOnAddStudent = () => {
        this.props.openAddStudentModal();
    }

    reloadStudentList = () => {
        const refreshStudentList = (this.props.lastAddedStudentUserProfileId > 0);
        if (refreshStudentList) {
            this.props.getProductStudents(this.props.selectedProduct.id);
        }
    }

    handleOnCloseAddStudentModal = () => {
        this.setState({ canSubmit: false });
        this.props.closeAddStudentModal();
        this.reloadStudentList();
    }

    handleOnCloseAddStudentValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeAddStudentValidationModal();
    }

    handleFilterOnClear = () => {
        this.props.clearFilterValue();
    }

    handleFilterOnChange = (collectionName, key) => {
        this.props.changeFilterValue(collectionName, key);
    }

    handleOnSearch = (searchTerm) => {
        this.props.updateSearchTerm(searchTerm);
    }

    handleRowSelect = (rows) => {
        this.props.retrieveSelectedStudents(rows);
    }

    handleOnAddStudentSubmit = () => {
        const student = clone(this.props.student);
        student.yearGroup = parseInt(student.yearGroup, 10);
        student.classroomId = parseInt(student.classroomId, 10);
        this.setState({ canSubmit: false });
        this.props.addStudent(student);
    }

    handleOnAddStudentGetGroups = (classroomId) => {
        this.props.getClassroomGroups(classroomId);
    }

    handleOnStudentUnassign= () => {
        this.setState({ showModal: true });
        this.props.openUnAssignStudentsModal();
    }

    handleOnUnassignConfirm = () => {
        this.props.unassignStudents(this.props.selectedStudents, this.props.selectedProduct.id);
    }

    handleOnCloseModal = () => {
        this.setState({ showModal: false });
        this.props.resetUserClassroomRelation();
    }

    handleOnAddAnotherStudent = () => {
        this.props.addAnotherStudentModal();
    }

    studentsOperationSuccessConfirmation =() => {
        this.handleOnCloseModal();
        this.props.closeStudentsOperationConfirmationModal();
    }

    handleOnStudentEdit = (userProfileId) => {
        trackEvent(ANALYTICS_EVENTS.actionClick, {
            action: 'edit',
            entity_type: 'student',
            module: ANALYTICS_MODULES.students,
            user_profile_id: userProfileId
        });
        this.context.router.history.push(`/edit-student/${userProfileId}`);
    }

    handleOnAssignClass = (id) => {
        const assignType = 'classToStudent';
        trackEvent(ANALYTICS_EVENTS.actionClick, {
            action: 'assign_class',
            entity_type: 'student',
            module: ANALYTICS_MODULES.students,
            user_profile_id: id
        });
        this.context.router.history.push(`/assign-user/${id}/${assignType}`);
    }

    handleOnStudentDeleteConfirmation = () => {
        const { students, selectedStudents } = this.props;
        const selectedStudentsForDelete = filter(students, student =>
            selectedStudents.indexOf(student.userProfileId) !== -1);

        const totalAssignedClasses = filter(selectedStudentsForDelete, student => student.assignedClassrooms.length > 0);
        const totalAssignedProducts = selectedStudentsForDelete.filter(student => student.accessibleProducts.length > 0);

        if (totalAssignedClasses.length > 0) {
            this.props.showToast(this.props.intl.formatMessage(messages.errorOnDeletingAssignedStudents), 'error');
        } else if (totalAssignedProducts.length > 0) {
            this.setState({ showModal: true });
            this.props.openDeleteUserConfirmation();
        } else {
            this.handleOnDeleteStudent();
        }
    }

    handleOnStudentDeleteClose = () => {
        this.setState({ showModal: false });
        this.props.closeStudentsOperationConfirmationModal();
    }

    handleOnDeleteStudent = () => {
        this.props.deleteStudentRequest(this.props.selectedStudents, this.props.selectedProduct.id);
    }

    handleOnStudentBulkPasswordChange = () => {
        this.setState({ showModal: true, bulkPasswordValue: '' });
        this.props.openBulkPasswordChangeStudentsModal();
    }

    handleOnStudentBulkPasswordChangeNewValue = (event) => {
        this.setState({
            bulkPasswordValue: event.target.value.trim()
        });
    }

    handleOnBulkPasswordChangeConfirm = () => {
        this.props.bulkPasswordChangeStudents(this.props.selectedStudents, this.state.bulkPasswordValue);
    }

    showDeleteConfirmationInToast = () => {
        const { deletedStudentsCount, isPartialDelete } = this.props;

        this.setState({ showModal: false });
        if (isPartialDelete) {
            this.props.showToast(`${this.props.intl.formatMessage(messages.partialDeleteMessage1)} 
            ${deletedStudentsCount} ${this.props.intl.formatMessage(messages.partialDeleteMessage2)}`, 'warning');
        } else {
            this.props.showToast(this.props.intl.formatMessage(messages.deleteStudentSuccess, { deletedStudentsCount })
                , 'success');
        }
        this.props.clearOperationTypeRequest();
    }

    handleOnDownSignInCards = () => {
        this.setState({ showModal: true });
        this.props.downloadStudentsSignInCards();
    }

    handleOnStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(true);
    }

    handleOnCancelStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(false);
    }

    render() {
        const rowGetter = rowNumber => this.state.rows[rowNumber];
        return (
            <StudentRoll
                addStudentValidationMessage={this.props.addStudentValidationMessage}
                bulkPasswordChangeSuccessConfirmation={this.bulkPasswordChangeSuccessConfirmation}
                bulkPasswordValue={this.state.bulkPasswordValue}
                classroomGroups={this.props.classroomGroups}
                classrooms={this.props.classrooms}
                closeAddStudentValidationModal={this.handleOnCloseAddStudentValidationModal}
                dataFilterOptions={this.state.dataFilterOption}
                deleteStudent={this.props.deleteStudentRequest}
                downloadStudentsSignInCards={this.handleOnDownSignInCards}
                filteredStudentsCount={this.props.filteredStudents.length}
                filterOnChange={this.handleFilterOnChange}
                filterOnClear={this.handleFilterOnClear}
                getClassroomGroups={this.handleOnAddStudentGetGroups}
                gridRowGetter={rowGetter}
                handleOnAddStudentSubmit={this.handleOnAddStudentSubmit}
                handleOnAssignClass={this.handleOnAssignClass}
                handleOnBulkPasswordChangeConfirm={this.handleOnBulkPasswordChangeConfirm}
                handleOnCancelStudentSignInCards={this.handleOnCancelStudentSignInCards}
                handleOnChangeBulkPasswordSetValue={this.handleOnStudentBulkPasswordChangeNewValue}
                handleOnCloseModal={this.handleOnCloseModal}
                handleOnDeleteConfirmation={this.showDeleteConfirmationInToast}
                handleOnDeleteStudent={this.handleOnDeleteStudent}
                handleOnPrintMultipleSignInCard={this.handleOnPrintMultipleSignInCard}
                handleOnPrintSignInCard={this.handleOnPrintSignInCard}
                handleOnStudentBulkPasswordChange={this.handleOnStudentBulkPasswordChange}
                handleOnStudentDeleteClose={this.handleOnStudentDeleteClose}
                handleOnStudentDeleteConfirmation={this.handleOnStudentDeleteConfirmation}
                handleOnStudentEdit={this.handleOnStudentEdit}
                handleOnStudentSignInCards={this.handleOnStudentSignInCards}
                handleOnStudentUnassign={this.handleOnStudentUnassign}
                handleOnUnassignConfirm={this.handleOnUnassignConfirm}
                isDeleteUserModalOpen={this.props.isDeleteUserModalOpen}
                isLoading={this.props.disableConfirmationButton}
                isSaveInProgress={this.props.isSaveInProgress}
                isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                isStudentDataLoaded={this.props.isStudentDataLoaded}
                isStudentRollDownloaded={this.props.isStudentRollDownloaded}
                isUserOperationModalOpen={this.props.isUserOperationModalOpen}
                onAddAnotherStudent={this.handleOnAddAnotherStudent}
                onAddStudent={this.handleOnAddStudent}
                onAddStudentCloseModal={this.handleOnCloseAddStudentModal}
                onDownloadStudentRoll={this.handleOnDownloadStudentRoll}
                onGridSort={this.handleGridSort}
                onQuickUpload={this.handleOnQuickUpload}
                onRowSelect={this.handleRowSelect}
                onSearch={this.handleOnSearch}
                operationType={this.props.operationType}
                selectedProduct={this.props.selectedProduct}
                selectedStudents={this.props.selectedStudents}
                showAddStudentConfirmationModal={this.props.showAddStudentConfirmationModal}
                showAddStudentsModal={this.props.showModal}
                showAddStudentValidationModal={this.props.showAddStudentValidationModal}
                showHideSignInCardModal={this.props.showHideSignInCardModal}
                showModal={this.state.showModal}
                student={this.props.student}
                students={this.state.rows}
                studentsCount={this.props.students.length}
                studentsOperationSuccessConfirmation={this.studentsOperationSuccessConfirmation}
            />
        );
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        classrooms: state.classRoll.classrooms,
        classroomGroups: state.studentRoll.classroomGroups,
        yearGroups: state.schoolRoll.yearGroups,
        selectedProduct: state.product,
        students: state.studentRoll.students,
        filteredStudents: state.studentRoll.filteredStudents,
        selectedStudents: state.studentRoll.selectedStudents,
        isStudentDataLoaded: state.studentRoll.isStudentDataLoaded,
        isClassroomDataLoaded: state.studentRoll.isStudentDataLoaded,
        isYearGroupDataLoaded: state.studentRoll.isYearGroupDataLoaded,
        isStudentRollDownloaded: state.studentRoll.isStudentRollDownloaded,
        dataFilterOption: state.studentRoll.dataFilterOption,
        showModal: state.studentRoll.showModal,
        student: state.studentRoll.studentModel,
        isSaveInProgress: state.studentRoll.isSaveInProgress,
        showAddStudentValidationModal: state.studentRoll.showAddStudentValidationModal,
        addStudentValidationMessage: state.studentRoll.addStudentValidationMessage,
        isSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
        showAddStudentConfirmationModal: state.studentRoll.showAddStudentConfirmationModal,
        lastAddedStudentUserProfileId: state.studentRoll.lastAddedStudentUserProfileId,
        isUserOperationModalOpen: state.studentRoll.isUserOperationModalOpen,
        refreshStudentList: state.studentRoll.refreshStudentList,
        disableConfirmationButton: state.studentRoll.disableConfirmationButton,
        isDeleteUserModalOpen: state.studentRoll.isDeleteUserModalOpen,
        operationType: state.studentRoll.operationType,
        unassignDisableButton: state.studentRoll.unassignDisableButton,
        bulkPasswordChangeDisableButton: state.studentRoll.bulkPasswordChangeDisableButton,
        deletedStudentsCount: state.studentRoll.deletedStudentsCount,
        isPartialDelete: state.studentRoll.isPartialDelete,
        showHideSignInCardModal: state.studentRoll.showHideSignInCardModal
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductStudents,
        getProductClassrooms,
        downloadStudentRoll,
        clearFilterValue,
        changeFilterValue,
        updateSearchTerm,
        sortStudentList,
        retrieveSelectedStudents,
        openAddStudentModal,
        closeAddStudentModal,
        addStudent,
        closeAddStudentValidationModal,
        printSignInCard,
        unassignStudents,
        addAnotherStudentModal,
        openUnAssignStudentsModal,
        closeStudentsOperationConfirmationModal,
        openDeleteUserConfirmation,
        deleteStudentRequest,
        openBulkPasswordChangeStudentsModal,
        bulkPasswordChangeStudents,
        showToast,
        clearOperationTypeRequest,
        getClassroomGroups,
        downloadStudentsSignInCards,
        showHideSignInCardModalRequest,
        resetUserClassroomRelation
    }, dispatch);
}

const intlContainer = injectIntl(StudentRollContainer);
export default connect(mapStateToProps, mapDispatchToProps)(intlContainer);



// WEBPACK FOOTER //
// ./app/containers/student-roll/index.js